import BaseService from './Base';

class PmsPlatforms extends BaseService {
  static endpoint = 'api/2.0/pms-platforms/';
}

export default PmsPlatforms;